<app-inner-box>
  <app-subpage-header title="Umlagerungen"></app-subpage-header>
  <app-list></app-list>
</app-inner-box>
